import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DeviationFilter } from '../../models';
import { WarningMessageType } from 'src/app/modules/shared/models/vehicle/vehicle-warning';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-deviation-filter',
    templateUrl: './deviation-filter.component.html',
    styleUrls: ['./deviation-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, ReactiveFormsModule, FormsModule, TranslateModule]
})
export class DeviationFilterComponent {
    @Input() warningType?: number;

    @Input() showHours = true;
    @Input() showMinutes = true;
    @Input() showSeconds = true;

    @Input() deviationsFilter: DeviationFilter;
    @Output() deviationFilterChanged: EventEmitter<DeviationFilter> = new EventEmitter<DeviationFilter>();
    public WarningTypeEnum = WarningMessageType;

    constructor() { }

    increaseDeviationFilter() {
        this.deviationsFilter.increase();
        this.emitDeviationFilterChanged();
    }

    decreaseDeviationFilter() {
        this.deviationsFilter.decrease();
        this.emitDeviationFilterChanged();
    }

    selectedDeviationMinutesChange(newValue: number) {
        this.deviationsFilter.minutes = newValue;
        this.updateDeviation();
    }

    selectedDeviationHoursChange(newValue: number) {
        this.deviationsFilter.hours = newValue;
        this.updateDeviation();
    }

    selectedDeviationSecondsChange(newValue: number) {
        this.deviationsFilter.seconds = newValue;
        this.updateDeviation();
    }

    private updateDeviation() {
        this.deviationsFilter.updateDeviation(
            this.deviationsFilter.hours,
            this.deviationsFilter.minutes,
            this.deviationsFilter.seconds
        );
        this.emitDeviationFilterChanged();
    }

    private emitDeviationFilterChanged() {
        this.deviationFilterChanged.emit(this.deviationsFilter);
    }
}
